import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[620px] md:h-[720px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=A%20dramatic%20atmospheric%20abstract%20art%20composition%20with%20flowing%20golden%20and%20deep%20crimson%20smoke%20like%20textures%2C%20dark%20elegant%20background%20with%20warm%20golden%20light%20rays%20breaking%20through%2C%20mysterious%20and%20romantic%20mood%2C%20no%20text%2C%20no%20people%2C%20abstract%20artistic%20style%2C%20cinematic%20atmosphere%2C%20high%20contrast%20dramatic%20lighting&width=1800&height=900&seq=hero-bg-2026&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/65"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
          <span className="text-xs md:text-sm text-accent-200 font-medium tracking-wider">每日更新 · 精品推荐</span>
        </div>

        <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4">
          都市美艳后宫
        </h1>
        <p className="text-lg md:text-xl lg:text-2xl text-background-50/80 font-heading mb-2">
          最强男主的极致宠溺之旅
        </p>
        <p className="text-sm md:text-base text-background-50/60 max-w-2xl mx-auto leading-relaxed mt-4">
          汇集最热血的都市爽文体验。从草根逆袭到万千美人环绕，极致宠溺与权谋并行，
          让你沉浸于最顶级的都市后宫幻想世界，感受无与伦比的阅读快感与情感共鸣。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
          <Link
            to="/category/urban-revenge"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full text-sm transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25 hover:shadow-primary-500/40"
          >
            开始阅读
            <span className="w-4 h-4 inline-flex items-center justify-center ml-1">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
          <Link
            to="/category/harem-development"
            className="px-8 py-3 bg-background-50/10 hover:bg-background-50/20 border border-background-50/30 text-background-50 font-semibold rounded-full text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            热门分类
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-12">
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-primary-300">12,000+</p>
            <p className="text-xs text-background-50/50 mt-1">精品小说</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-accent-300">580万+</p>
            <p className="text-xs text-background-50/50 mt-1">忠实读者</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-primary-300">3.6亿+</p>
            <p className="text-xs text-background-50/50 mt-1">字内容</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-8 h-8 flex items-center justify-center text-background-50/50">
          <i className="ri-arrow-down-line text-lg"></i>
        </div>
      </div>
    </section>
  );
}